import React from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { API_URL } from "../../../config/environment";
import PersonAvatar from "../../../images/person-avatar.svg";
import { FormattedMessage } from "react-intl";
import { Button, Checkbox, Dropdown, Icon, Menu, Popover, Table } from "antd";
import EditIcon from "../../../images/edit.svg";
import MoreIcon from "../../../images/more.svg";
import DeleteIcon from "../../../images/delete.svg";
import { LoadingSpinner } from "../LoadingSpinner";

function TableLayout({
  hideColumns,
  handleViewPersonBtnClick,
  rowSelection,
  loading,
  handleTableChange,
  imgError,
  people,
  page,
  totalNumberOfPeople,
  handlePersonDelete,
  handleEditPersonBtnClick,
  handleMoreButtonClick,
  tableFor,
  toggleSortingColumnsChecked,
  sortingColumns,
  sortedColumns,
  canEditPerson,
}) {
  const columns = [
    {
      title: "",
      dataIndex: "Photo",
      key: "photo",
      width: 1,
      fixed: true,
      render: (fileName, record) => {
        return (
          <span className={classNames(styles.avatar, "profile-photo")}>
            <img
              style={{ width: 25, height: 25, borderRadius: 13 }}
              src={fileName ? fileName : PersonAvatar}
              alt=""
              onError={imgError}
            />
          </span>
        );
      },
      className: sortedColumns.includes("Photo")
        ? "show profile-photo-cont"
        : "hide profile-photo-cont",
    },

    {
      title: <FormattedMessage id="Name" defaultMessage="Name" />,
      dataIndex: "Name",
      key: "name",
      // width: 250,
      render: (text) => <b>{text}</b>,
      className: sortedColumns.includes("Name") ? "show" : "hide",
    },

    {
      title: (
        <FormattedMessage id="PhoneNumber" defaultMessage="Phone Number" />
      ),
      dataIndex: "Phone Number",
      key: "phoneNumber",
      className: sortedColumns.includes("Phone Number") ? "show" : "hide",
    },
    {
      title: <FormattedMessage id="Email" defaultMessage="Email" />,
      dataIndex: "Email",
      key: "email",
      className: sortedColumns.includes("Email") ? "show" : "hide",
    },
    {
      title: <FormattedMessage id="Occupation" defaultMessage="Occupation" />,
      dataIndex: "Occupation",
      key: "occupation",
      className: sortedColumns.includes("Occupation") ? "show" : "hide",
    },
    {
      title: <FormattedMessage id="IDNumber" defaultMessage="ID Number" />,
      dataIndex: "Id Number",
      key: "idNumber",
      className: sortedColumns.includes("Id Number") ? "show" : "hide",
    },
    {
      title: <FormattedMessage id="Gender" defaultMessage="Gender" />,
      dataIndex: "Gender",
      key: "gender",
      className: sortedColumns.includes("Gender") ? "show" : "hide",
    },
    {
      title: <FormattedMessage id="Title" defaultMessage="Title" />,
      dataIndex: "Title",
      key: "title",
      className: sortedColumns.includes("Title") ? "show" : "hide",
    },
    {
      title: <FormattedMessage id="Country" defaultMessage="Country" />,
      dataIndex: "Country",
      key: "country",
      className: sortedColumns.includes("Country") ? "show" : "hide",
    },
    {
      title: <FormattedMessage id="City" defaultMessage="City" />,
      dataIndex: "City",
      key: "city",
      className: sortedColumns.includes("City") ? "show" : "hide",
    },
    {
      title: (
        <FormattedMessage id="DateOfBirth" defaultMessage="Date Of Birth" />
      ),
      dataIndex: "Date of Birth",
      key: "dateOfBirth",
      className: sortedColumns.includes("Date of Birth") ? "show" : "hide",
    },
    {
      title: (
        <FormattedMessage id="GPSLocation" defaultMessage="GPS Location" />
      ),
      dataIndex: "GPS Location",
      key: "gpsLocation",
      className: sortedColumns.includes("GPS Location") ? "show" : "hide",
    },
    {
      title: (filters, sortOrder) => {
        return (
          <React.Fragment>
            {sortingColumns.length > 0 && (
              <Popover
                content={
                  <React.Fragment>
                    {sortingColumns.map((s, index) => {
                      return (
                        <Checkbox
                          name={s.title}
                          onChange={(e) => toggleSortingColumnsChecked(e, s)}
                          defaultChecked={sortedColumns.includes(s.title)}
                          checked={sortedColumns.includes(s.title)}
                          key={index}
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            marginLeft: 0,
                          }}
                          value={s.title}
                        >
                          {s.title}
                        </Checkbox>
                      );
                    })}
                  </React.Fragment>
                }
                title="FIELDS TO DISPLAY"
                placement="bottomLeft"
                trigger="click"
              >
                <Button
                  title="Display more fields"
                  type="default"
                  data-dfs-people-id="edit-columns-link"
                >
                  {/* <Icon component={EditTableIcon} /> */}
                  <Icon type="eye" theme="filled" />{" "}
                  <span style={{ fontWeight: "normal" }}>
                    <FormattedMessage
                      id="App.Text.MoreFields"
                      defaultMessage={"More fields"}
                    />
                  </span>
                </Button>
              </Popover>
            )}
          </React.Fragment>
        );
      },
      align: "right",
      // fixed: true,
      render: (text, record) => (
        <div
          className={classNames(styles.hidden, "actionButtons")}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {canEditPerson && (
            <Button
              data-dfs-people-id={`edit-person-${record.key}-button}`}
              type="link"
              style={{ paddingRight: 5 }}
              onClick={(e) => handleEditPersonBtnClick(e, record)}
            >
              <img style={{ width: 12 }} src={EditIcon} alt="Delete Icon" />
            </Button>
          )}

          {tableFor === "group" ? (
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu onClick={(e) => handleMoreButtonClick(e, record)}>
                  <Menu.Item
                    disabled={canEditPerson === false}
                    key="remove-from-group"
                  >
                    <FormattedMessage
                      id="Button.RemoveFromGroup"
                      defaultMessage="Remove from this group"
                    />
                  </Menu.Item>
                  <Menu.Item
                    disabled={canEditPerson === false}
                    key="delete-person"
                    onClick={(e) => handlePersonDelete(e, [record["key"]])}
                  >
                    <FormattedMessage
                      id="Button.DeletePerson"
                      defaultMessage="Delete person"
                    />
                  </Menu.Item>
                  <Menu.Item key="add-to-another-group">
                    <FormattedMessage
                      id="Button.AddAnotherGroup"
                      defaultMessage="Add to another group"
                    />
                  </Menu.Item>
                </Menu>
              }
            >
              <Button
                style={{ paddingLeft: 5 }}
                type="link"
                data-dfs-people-id={`person-more-options-${record.key}-button}`}
              >
                <img src={MoreIcon} alt="More Icon" />
              </Button>
            </Dropdown>
          ) : (
            <Button
              data-dfs-people-id={`delete-person-${record.key}-button}`}
              type="link"
              style={{ paddingLeft: 5, paddingRight: 5 }}
              onClick={(e) => handlePersonDelete(e, [record["key"]])}
            >
              <img style={{ width: 12 }} src={DeleteIcon} alt="Delet Icon" />
            </Button>
          )}
        </div>
      ),
    },
  ];
  return (
    <Table
      // useFixedHeader={true}
      scroll={{ x: "max-content" }}
      size="small"
      pagination={{
        total: totalNumberOfPeople,
        page: page,
        pageSize: 250,
        showTotal: (total) =>
          people.length === 250
            ? `${page > 1 ? (page - 1) * 250 + 1 : 1} - ${
                people.length * page
              } out of ${total}`
            : `${
                page > 1 ? (page - 1) * 250 + 1 : 1
              } - ${total} out of ${total}`,
      }}
      loading={{ indicator: LoadingSpinner, spinning: loading }}
      onChange={handleTableChange}
      rowSelection={{ hideDefaultSelections: true, ...rowSelection }}
      dataSource={people}
      columns={hideColumns ? null : columns}
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => handleViewPersonBtnClick(event, record),
        };
      }}
    />
  );
}

export default TableLayout;
